import { Button, Group, Paper, Stack, Text } from "@mantine/core";
import { IconMoodWrrr } from "@tabler/icons-react";

function ErrorFallback() {
  return (
    <Paper withBorder m="md" p="md">
      <Stack>
        <Group mt="md">
          <IconMoodWrrr size={50} />
          <Text fz="xl">Something went wrong</Text>
        </Group>
        <Text mt="lg">
          Sorry about that! Our team has been notified and will look into the
          error.
        </Text>
        <Button variant="default" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </Stack>
    </Paper>
  );
}

export default ErrorFallback;
